import * as Sentry from '@sentry/browser';
import { getGlobalObject } from './utils';

Sentry.init({
  dsn: 'https://176c9ba8204a40ca85bbafbad71d4f83@o82379.ingest.sentry.io/5708345',
  integrations: [
    Sentry.inboundFiltersIntegration(),
    Sentry.functionToStringIntegration(),
    Sentry.breadcrumbsIntegration(),
    Sentry.globalHandlersIntegration(),
    Sentry.linkedErrorsIntegration(),
    Sentry.dedupeIntegration(),
  ],
  tracesSampleRate: 1.0,
  enabled: process?.env?.NODE_ENV === 'production',
  transport: Sentry.makeFetchTransport,
  stackParser: Sentry.defaultStackParser,
});

const PREFIX = 'Gordian Logger';

const global = getGlobalObject<Window>();

class Logger {
  private _enabled: boolean;

  public constructor() {
    this._enabled = false;
  }

  public disable(): void {
    this._enabled = false;
  }

  public enable(): void {
    this._enabled = true;
  }

  public log(...args: any[]): void {
    if (!this._enabled) {
      return;
    }
    global.console.log(`${PREFIX}[Log]: ${args.join(' ')}`);
  }

  public error(...args: any[]): void {
    if (!this._enabled) {
      return;
    }
    global.console.error(`${PREFIX}[Error]: ${args.join(' ')}`);
  }

  public sentryContext(name: string, object: Object): void {
    Sentry.setContext(name, object as { [key: string]: unknown });
  }

  public sentryTag(name: string, value: string): void {
    Sentry.setTag(name, value);
  }

  public sentryError(error: Error): void {
    Sentry.captureException(error);
  }
}

global.__GORDIAN__ = global.__GORDIAN__ || {};
const logger = (global.__GORDIAN__.logger as Logger) || (global.__GORDIAN__.logger = new Logger());

export { logger };
